<script setup lang="ts">
defineEmits<{ retry: [] }>()
</script>

<template>
  <div class="flex items-center justify-center gap-2.5 px-4 py-2 bg-red-50 border-t border-red-200 text-red-600 text-[13px] shrink-0">
    <span>Connection lost — response may be incomplete.</span>
    <button
      class="px-3 py-1 bg-red-600 hover:bg-red-500 text-white rounded text-xs transition-colors"
      @click="$emit('retry')"
    >
      Retry
    </button>
  </div>
</template>
